import {
  UPDATE_PROFILE_SUCCESS,
  ADD_RECIPE_TO_FAVORITES_OPTIMISTIC,
  REMOVE_RECIPE_FROM_FAVORITES_OPTIMISTIC,
} from "./actionTypes";
import * as userProfileApi from "../../api/userProfileApi";

export function updateProfileSuccess(profile) {
  return { type: UPDATE_PROFILE_SUCCESS, profile };
}

export function addRecipeToFavoritesOptimistic(recipeId) {
  return { type: ADD_RECIPE_TO_FAVORITES_OPTIMISTIC, recipeId };
}

export function removeRecipeFromFavoritesOptimistic(recipeId) {
  return { type: REMOVE_RECIPE_FROM_FAVORITES_OPTIMISTIC, recipeId };
}

export function handleFavorite(recipeId, favorite) {
  return function (dispatch) {
    const token = sessionStorage.getItem("cb_token");

    if (favorite) {
      dispatch(addRecipeToFavoritesOptimistic(recipeId));
    } else {
      dispatch(removeRecipeFromFavoritesOptimistic(recipeId));
    }
    return userProfileApi.saveRecipeToProfileFavorites(
      recipeId,
      favorite,
      token
    );
  };
}
